import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import Logo from './Logo';
import LoggedInAvatar from './LoggedInAvatar';
import Notification from './Notification';
import { Message } from '@mui/icons-material';
import { useAuth } from '../../context/authContext';


const ResponsiveAppBar: React.FC = () => {
  const { isAuthenticated } = useAuth();

  const theme = useTheme();

  return (
    <AppBar 
        position="fixed"
        sx={{
        background: theme.palette.primary.main,
        boxShadow: 2,
        height: '6em',
        justifyContent: 'center',
        transition: 'background-color 0.3s ease',
        }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{justifyContent: 'space-between', mr: 3}}>
          <Logo />
          <Box sx={{ flexGrow: 0 }}>
            {isAuthenticated && <>
              <Notification />
              <LoggedInAvatar />
              </>}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
